<template>
  <v-select
    v-model="internalValue"
    :clearable="!required"
    :multiple="multiple"
    :searchable="false"
    label="name"
    :options="shippingStatusOptions"
    :placeholder="$t('orders.status')"
    :class="['select-chip select-status', customClass]"
  >
    <template slot="no-options"> {{ $t("noRecord") }} </template>

    <template slot="option" slot-scope="option">
      <div :class="`option-chip status-${option.id}`">
        <OrderStatus v-if="option?.name" :item="option.name" />
      </div>
    </template>
    <template slot="selected-option" slot-scope="option">
      <div :class="`option-chip status-${option.id} selected`">
        <OrderStatus :item="option.name" />
      </div>
    </template>
    <template #open-indicator="{}">
      <i class="md-icon md-icon-font md-icon-image md-theme-default">
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 10l5 5 5-5z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </i>
    </template>
  </v-select>
</template>

<script>
import { normalizeStatusName } from "../../mixins/formats";
import OrderStatus from "./OrderStatus.vue";

export default {
  components: {
    OrderStatus,
  },
  props: {
    value: {
      type: [String, Array, Object, Number, null],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: null, // Fallback value
      shippingStatusOptions: [],
    };
  },
  computed: {
    internalValue: {
      get() {
        let parsedValue = [];

        if (!this.value) {
          return this.localValue;
        }
        if (Array.isArray(this.value)) {
          parsedValue = [...this.value];
        } else if (typeof this.value === "string") {
          parsedValue = this.value.split(",");
        } else {
          parsedValue = [this.value];
        }
        const res =
          parsedValue?.map((val) => {
            return this.shippingStatusOptions.find((stt) => {
              return stt.id === Number(val);
            });
          }) ?? null;

        return res;
      },
      set(newValue) {
        if (!newValue) {
          this.localValue = newValue;
          this.$emit("input", null);
          return;
        }

        this.localValue = newValue;
        if (this.multiple === true) {
          if (newValue.length === 0) {
            this.$emit("input", null);
            return;
          } else {
            this.$emit(
              "input",
              newValue?.map((item) => item.id)
            );
          }
        } else {
          this.$emit("input", newValue.id);
        }
      },
    },
  },
  methods: {
    getI18N(prefix, statusName) {
      return this.$t(`${prefix}.${normalizeStatusName(statusName)}`);
    },
  },
  created() {
    if (!this.$store.state.shippingData.shippingStatus || this.$store.state.shippingData.shippingStatus.length === 0) {
      this.$store.dispatch("shippingData/getShippingStatuses").then((res) => {
        console.log("res", res);
        this.shippingStatusOptions = [...res];
      });
    } else {
      this.shippingStatusOptions = [...this.$store.state.shippingData.shippingStatus];
    }
  },
};
</script>

<style lang="scss"></style>
